import React, { useState } from 'react'
import PadContainer from '../../../components/PadContainer'
import TitleContainer from '../../../components/TitleContainer'
import { Button, Drawer, Form, Select, Tag } from 'antd'
import { formatCurrency, handleTableSelect } from '../../../context/utils'
import CustomTable from '../../../components/CustomTable'
import { useGetTransactions } from '../../../hooks/transaction/transaction'
import { useGetPaymentMethods } from '../../../hooks/business/business'
import PaginationPage from '../../../components/paginationPage'
import SearchPage from '../../../components/searchPage'

function ReportsManagementPage() {

  const [isFilter, setIsFilter] = useState(false)
  const [page, setPage] = useState(0)
  const [search, setSearch] = useState('')
  const [params, setParams] = useState({})

  const onFilterOpen = () => setIsFilter(true)

  const [rows, setRows] = useState([])

  const width = window.innerWidth
  const isMobile = width <= 500
  
  const [form] = Form.useForm()

  const {
    data: getPay,
  } = useGetPaymentMethods()

  const onFilterClose = () => {
    form.resetFields()
    setIsFilter(false)
    setRows([])
  }
  
  const {
    data: getData,
    refetch: getFetch,
    isFetching: getLoad,
  } = useGetTransactions(
    { pageNumber:page, searchString: search, ...params },
    ["pageNumber", "searchString", "status", "type", "paymentMethodId"],
  );

  const columns = [
    {
      title: "First Name",
      dataIndex: "user",
      key:"firstName",
      render: (e) => 
        <p className='text-sm font-medium text-dim'>{e?.firstName}</p>
    },
    {
      title: "last Name",
      dataIndex: "user",
      key:"lastName",
      render: (e) => 
        <p className='text-sm font-medium text-dim'>{e?.lastName}</p>
    },
    {
      title: "Email",
      dataIndex: "user",
      key:"email",
      render: (e) => 
        <p className='text-sm font-medium text-dim'>{e?.email}</p>
    },
    {
      title: "User Type",
      dataIndex: "user",
      key:"userType",
      render: (e) => 
        <p className='text-sm font-medium text-dim'>{e?.userType}</p>
    },
    {
      title: "Amount Paid",
      dataIndex: "amountPaid",
      key:"amountPaid",
      render: (e) => 
        <p className='text-sm font-medium text-dim'>{formatCurrency(e)}</p>
    },
    {
      title: "Payment Method",
      dataIndex: "paymentMethod",
      key:"paymentMethod",
      render: (e) => 
        <p className='text-sm font-medium text-dim'>{e.name}</p>
    },
    {
      title: "Status",
      dataIndex: "status",
      key:"2",
      render: (e) => 
      <Tag className={`font-bold rounded-2xl px-3 py-0.5`} color={e !=="Pending" ? 'green': 'red'}>{e}</Tag>
    },
    {
      title: "Date",
      dataIndex: "dateInitiated",
      key:"dateInitiated",
      render: (e) => 
        <p className='text-sm font-medium text-dim'>{new Date(e).toDateString()}</p>
    },
  ]

  const onSubmit = (d) => {
    setParams(d)
    onFilterClose()
  }


  return (
    <PadContainer loading={getLoad}>
      <TitleContainer
        path={false}
        title="Transactions"
        className="border border-lit rounded-xl"
        action={<div className='flex'>
          <SearchPage setSearch={setSearch} size='' />
          <Button onClick={onFilterOpen} className='!bg-light_blue mx-2' type='primary'>Filter</Button>
        </div>}
      >
        <CustomTable
          pagination= {false}
          column={columns}
          data={getData?.data?.data || []}
          rowSelection={handleTableSelect(rows, setRows, "_id")}
        />
        <PaginationPage 
          data={getData}
          setPage={setPage}
        />
      </TitleContainer>


      {/* Filter create drawer */}
      <Drawer
        open={isFilter}
        onClose={onFilterClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Filter</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          className='relative'
        >
        <Form.Item label="Status" name='status'>
          <Select 
              size='large' 
              placeholder='Filter by Status' 
              allowClear               
          >
              <Select.Option value="Pending">Pending</Select.Option>
              <Select.Option value="Processing">Processing</Select.Option>
              <Select.Option value="Completed">Completed</Select.Option>
              <Select.Option value="Failed">Failed</Select.Option>
          </Select>
        </Form.Item> 
        <Form.Item label="Transaction Type" name='type'>
          <Select 
              size='large' 
              placeholder='Filter by Transaction Type' 
              allowClear                
          > 
              <Select.Option value="InsuranceSubscription">Insurance Subscription</Select.Option>
              <Select.Option value="AdSubscription">Ad Subscription</Select.Option>
              <Select.Option value="BusinessSubscription">Business Subscription</Select.Option>
              <Select.Option value="DeviceInsurance">Device Insurance</Select.Option>
          </Select>
        </Form.Item> 
        <Form.Item label="Payment Method" name="paymentMethodId">
          <Select size='large' placeholder='Select Payment Method' allowClear>
            {getPay?.data?.map((e)=>(
              <Select.Option value={e.id}>{e.name}</Select.Option>
            ))}
          </Select>
        </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onFilterClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Filter</Button>
          </div>
        </Form>
      </Drawer>
    </PadContainer>
  )
}

export default ReportsManagementPage